// bright
export const brightOption = [
  {
    label: (
      <div
        className="ant-select"
        style={{
          width: 40,
          padding: 5,
        }}
      >
        <div>Light</div>
      </div>
    ),
    value: "Light",
  },
  {
    label: (
      <div
        className="ant-select"
        style={{
          width: 40,
          padding: 5,
        }}
      >
        <div>Dark</div>
      </div>
    ),
    value: "Dark",
  },
];

// orders選擇
const ordersOption = [
  {
    label: (
      <div
        className="ant-select"
        style={{
          width: 96,
          padding: 10,
        }}
      >
        <div>預約訂單</div>
      </div>
    ),
    value: "orders",
  },
  {
    label: (
      <div
        className="ant-select"
        style={{
          width: 96,
          padding: 10,
        }}
      >
        <div>活動列表</div>
      </div>
    ),
    value: "registrations",
  },
];
// reservation選擇
const reservationOption = [
  {
    label: (
      <div
        className="ant-select"
        style={{
          width: 96,
          padding: 10,
        }}
      >
        <div>報名</div>
      </div>
    ),
    value: "報名",
  },
  {
    label: (
      <div
        className="ant-select"
        style={{
          width: 96,
          padding: 10,
        }}
      >
        <div>預約</div>
      </div>
    ),
    value: "預約",
  },
];
// registration選擇
const registrationOption = [
  {
    label: (
      <div
        className="ant-select"
        style={{
          width: 96,
          padding: 10,
        }}
      >
        <div>報名</div>
      </div>
    ),
    value: "報名",
  },
  {
    label: (
      <div
        className="ant-select"
        style={{
          width: 96,
          padding: 10,
        }}
      >
        <div>預約</div>
      </div>
    ),
    value: "預約",
  },
];

export const showMenu = (page) => {
  const menuMap = {
    orders: ordersOption,
    reservation: reservationOption,
    registration: registrationOption,
  };
  return menuMap[page] || [];
};

const breadcrumbsText = {
  statistics: {
    value: "數據",
    performanceReport: { value: "業績報表" },
    virtualPerformanceReport: { value: "虛擬業績報表" },
    consultantPerformance: { value: "諮詢師業績" },
    verificationReport: { value: "核銷明細報表" },
    ledgerReport: { value: "回饋金/點數管理報表" },
    personalProfit: { value: "個人分潤" },
    performanceBonusTrial: { value: "業績獎金級距試算" },
    "orderPerformanceDetails": { value: "訂單業績明細" },
    "commentAnalysis": { value: "評論分析" },
    // daily: { value: "每日業績" },
    // performancesetting: { value: "業績分潤設定", personaloverview: { value: "個人分潤加成總覽" } },
  },
  tickets: {
    value: "票券",
    commodity: { value: "商品票券" },
    activity: { value: "活動票券" },
    administration: { value: "課程管理" },
    ticketManagement: { value: "課程管理" },
    cardManagement: { value: "卡項管理" },
  },
  sales: {
    value: "銷售",
    index: { value: "首頁" },
    topup: { value: "儲值金結帳" },
    ticket: { value: "課程結帳" },
    redemption: { value: "核銷" },
    checkoutrecord: { value: "結帳紀錄" },
    consumablesrecord: { value: "耗材紀錄" },
    consumablesitem: { value: "耗材紀錄" },
    "balance-payment": { value: "待付尾款總表" },
  },
  customer: {
    value: "會員",
    list: { value: "會員列表" },
    "intake-form": { value: "初診單管理" },
    "document-batch-print": { value: "文件批次列印" },
    "signing-center": { value: "簽署中心" },
    bulksending: { value: "群發訊息/課程" },
    transfer: { value: "轉贈紀錄" },
    exchange: { value: "換購紀錄" },
  },
  shiftschedule: {
    value: "班表",
    employees: { value: "團隊成員" },
    broker: { value: "經紀人" },
    shifts: { value: "設定班別" },
    employeeshifts: { value: "管理班表" },
    service: {
      value: "服務上架管理",
      categorymanagement: { value: "分類管理" },
    },
    consent: {
      value: "術前同意書",
    },
    "consent-templates": { value: "範本設定" },
    "consent-category-link": { value: "對應服務分類" },
    "consent-service-link": { value: "服務關聯設定" },
    "consent-service-edit": { value: "服務關聯設定" },
    "consent-category-edit": { value: "對應服務分類" },
    "payment-consent-template": { value: "範本設定" },
    "payment-consent-category-link": { value: "對應服務分類" },
    "payment-consent-service-link": { value: "服務關聯設定" },
    "payment-consent-service-edit": { value: "服務關聯設定" },
    "payment-consent-category-edit": { value: "對應服務分類" },
    "post-treatment-consent-template": { value: "療程後確認單" },
    questionnaire: {
      value: "問卷單",
    },
    "questionnaire-templates": { value: "範本設定" },
    "questionnaire-category-link": { value: "對應服務分類" },
    "questionnaire-service-link": { value: "服務關聯設定" },
    "questionnaire-service-edit": { value: "服務關聯設定" },
    "questionnaire-category-edit": { value: "對應服務分類" },
    "questionnaire-editor": { value: "範本設定" },
  },
  options: {
    value: "設定",
    company: { value: "公司資訊" },
    branch: {
      value: "分店資訊",
      ":branchId": { value: "分店帳號設定" }
    },
    consulting: { value: "診間設定" },
    "member-management": { value: "等級設定" },
    "purchase-gift": { value: "贈品規則" },
    label: { value: "標籤管理" },
    blacklist: { value: "黑名單管理" },
    cancellationpolicysettings: { value: "取消政策設定" },
    deposit: { value: "訂金管理" },
    message: {
      value: "訊息設定",
      autoreply: { value: "自動化訊息設定" },
      bulksending: { value: "群發訊息設定" },
      messagetemplate: { value: "訊息範本管理" }
    },
    autoreply: { value: "自動化訊息設定" },
    bulksending: { value: "群發訊息設定" },
    messagetemplate: { value: "訊息範本管理" },
    topup: { value: "儲值金管理" },
    point: { value: "品牌點數管理" },
    coupon: { value: "優惠券管理" },
    discount: { value: "折扣管理" },
    pay: { value: "POS付款/發票設定" },
    accountauthority: { value: "帳號權限管理" },
    serviceplan: { value: "服務方案及繳款" },
    "payment-gateway": { value: "API串接" },
    preferences: { value: "喜好設定" },
    password: { value: "修改密碼" },
    thirdparty: { value: "第三方工具整合" },
    manual: { value: "OBS 操作手冊" },
    "intake-form": { value: "初診單設定" },
    "canned-message": { value: "罐頭訊息" },
    "treatment-record-templates": { value: "療程紀錄模板" },
  },
};


export const breadcrumbs = (routerName, pagination, subPage, branchName = null) => {
  // 請採驗：PimsLayout 內建麵包屑，頂部不重複顯示
  // 銷售：首頁全版卡片、子頁自有返回列＋標題，不用全站 NewHeader 麵包屑
  if (routerName === "pims" || routerName === "sales") {
    return [];
  }

  const routerNameText = breadcrumbsText[routerName]?.value;
  let paginationText = breadcrumbsText[routerName]?.[pagination]?.value;
  let subPageText = breadcrumbsText[routerName]?.[pagination]?.[subPage]?.value;

  // 銷售首頁 /sales 無第二 path 段，與 /sales/index 同樣顯示「銷售 > 首頁」
  if (routerName === "sales" && !pagination) {
    return [
      { text: routerNameText, href: "" },
      { text: breadcrumbsText.sales?.index?.value, href: "" },
    ].filter((item) => item.text);
  }

  // 特殊處理：當在分店帳號設定頁面時（/options/branch/:branchId）
  if (routerName === 'options' && pagination === 'branch' && subPage && !isNaN(subPage)) {
    // subPage 是數字（branchId）
    const baseText = breadcrumbsText.options.branch[":branchId"]?.value; // "分店帳號設定"
    const breadcrumbText = branchName ? `${baseText}-${branchName}` : baseText;
    return [
      { text: routerNameText, href: "" }, // "設定"
      { text: paginationText, href: "" }, // "分店資訊"
      { text: breadcrumbText, href: "" }, // "分店帳號設定-{分店名稱}"
    ].filter((item) => item.text);
  }

  // 特殊處理：當在自動化訊息設定頁面時，顯示三層麵包屑
  if (routerName === 'options' && pagination === 'autoreply') {
    return [
      { text: routerNameText, href: "" },
      { text: breadcrumbsText.options.message.value, href: "" },
      { text: breadcrumbsText.options.autoreply.value, href: "" },
    ].filter((item) => item.text);
  }

  // 班表 > 服務設定 > 服務上架管理 / 分類管理 / 成本與分潤（對齊側邊欄層級）
  if (routerName === 'shiftschedule' && pagination === 'service') {
    return [
      { text: routerNameText, href: "" },
      { text: "服務設定", href: "" },
      { text: "服務上架管理", href: "" },
    ].filter((item) => item.text);
  }
  if (routerName === 'shiftschedule' && pagination === 'categorymanagement') {
    return [
      { text: routerNameText, href: "" },
      { text: "服務設定", href: "" },
      { text: "分類管理", href: "" },
    ].filter((item) => item.text);
  }
  if (routerName === 'shiftschedule' && pagination === 'service-cost') {
    return [
      { text: routerNameText, href: "" },
      { text: "服務設定", href: "" },
      { text: "成本與分潤", href: "" },
    ].filter((item) => item.text);
  }

  // 班表 > 術前同意書 > xxx
  if (routerName === 'shiftschedule' && ['consent-templates', 'consent-category-link', 'consent-service-link', 'consent-service-edit', 'consent-category-edit'].includes(pagination)) {
    return [
      { text: routerNameText, href: "" },
      { text: breadcrumbsText.shiftschedule.consent.value, href: "" },
      { text: breadcrumbsText.shiftschedule[pagination]?.value, href: "" },
    ].filter((item) => item.text);
  }

  // 班表 > 付款同意書 > xxx
  if (routerName === 'shiftschedule' && ['payment-consent-template', 'payment-consent-category-link', 'payment-consent-service-link', 'payment-consent-service-edit', 'payment-consent-category-edit'].includes(pagination)) {
    return [
      { text: routerNameText, href: "" },
      { text: "付款同意書", href: "" },
      { text: breadcrumbsText.shiftschedule[pagination]?.value, href: "" },
    ].filter((item) => item.text);
  }

  // 班表 > 療程後確認單
  if (routerName === "shiftschedule" && pagination === "post-treatment-consent-template") {
    return [
      { text: routerNameText, href: "" },
      { text: breadcrumbsText.shiftschedule["post-treatment-consent-template"]?.value, href: "" },
    ].filter((item) => item.text);
  }

  // 班表 > 問卷單 > xxx
  if (routerName === 'shiftschedule' && ['questionnaire-templates', 'questionnaire-category-link', 'questionnaire-service-link', 'questionnaire-service-edit', 'questionnaire-category-edit', 'questionnaire-editor'].includes(pagination)) {
    return [
      { text: routerNameText, href: "" },
      { text: breadcrumbsText.shiftschedule.questionnaire.value, href: "" },
      { text: breadcrumbsText.shiftschedule[pagination]?.value, href: "" },
    ].filter((item) => item.text);
  }

  return [
    { text: routerNameText, href: "" },
    { text: paginationText, href: "" },
    { text: subPageText, href: "" },
  ].filter((item) => item.text);
  // 若有可以點擊的子路由，可以打開以下註解並把上方整個 return 的 array 註解掉
  // return [
  //   {
  //     text: routerNameText,
  //     href: `/${routerName}`, // 路由名稱
  //   },
  //   {
  //     text: paginationText,
  //     href: pagination ? `/${routerName}/${pagination}` : "", // 分頁路由
  //   },
  //   {
  //     text: subPageText,
  //     href: subPage ? `/${routerName}/${pagination}/${subPage}` : "", // 子頁面路由
  //   },
  // ].filter((item) => item.text); // 過濾掉沒有 `text` 的項目
};
